/**
 * Gate CTA value-forward copy — DECIDED, no longer an experiment.
 *
 * History: shipped 2026-07-07 as the 50/50 "gate-cta-value-prop" A/B
 * (`control` = generic "sign up free" ask, `variant` = this value-forward
 * copy) across every guest signup-gate CTA. Ended 2026-07-14: at ~50 gate
 * clicks/week split across arms the test needed months to reach power, and
 * the pre-2026-07-14 exposure counts were corrupted by the per-card
 * `experiment_exposure` bug (fixed in PR #2326) — unreadable either way.
 * The PostHog flag was pinned variant=100 and is no longer read anywhere;
 * it can be archived once this code is deployed.
 *
 * Copy revised 2026-07-19: the original variant promised "match alerts",
 * which no signed-up user actually receives — new-job alerts only fire for
 * a *saved search* with alerting turned on (`saved-searches` page,
 * `new-jobs-alert-enqueuer.ts`), a separate opt-in this CTA never sets up.
 * What a signup here actually gets: the outbound apply click gets recorded
 * to their application tracker (`trackOutboundClick`, gated by the
 * `retention-apply-autotrack` flag — fully rolled out since 2026-07-14) and
 * surfaces a "did you apply?" follow-up, both on the /applications page
 * (`ClickedFollowupList`) and in the next daily-brief email
 * (`clicked-followup-block.ts`). That autotrack write itself still fails
 * silently on error (a separate visibility gap, tracked for PR 1 of this
 * series) — but the write path and the follow-up surfaces are real and
 * live regardless of that other PR's merge state, so this copy holds either
 * way.
 */

/**
 * The value-forward CTA copy — the guest signup-gate ask on every surface
 * (`apply_signup_gate` in job-apply-cta.tsx, `feed_card_locked` guest branch
 * in job-row.tsx, `filter_auth_gate` signup button in login-modal.tsx).
 */
export const GATE_CTA_VALUE_PROP_COPY = {
	en: "Track this application + get a follow-up reminder",
	id: "Simpan & lacak lamaranmu + dapat pengingat follow-up",
} as const;

/** Locale-resolved value-forward CTA label. Defaults to English for any
 * locale other than "id", matching the existing `locale === "id" ? ... : ...`
 * idiom used for hardcoded bilingual copy elsewhere in these components. */
export function gateCtaValueLabel(locale: string | undefined): string {
	return locale === "id"
		? GATE_CTA_VALUE_PROP_COPY.id
		: GATE_CTA_VALUE_PROP_COPY.en;
}
